import moment from 'moment';
import '../stations/Station.scss';

export const CustomTooltip:any = (props:any) => {
  const {active, label,payload}=props;
  if (active && payload && payload.length) {
    return (
      <div id="custom-tooltip" className="custom-tooltip" style={{backgroundColor: 'white', border: 'none !important', display:'block', }}>
        <span className="month" style={{fontSize: '.75rem', paddingBottom: '0px', paddingTop:'0px', display:'block'}}>
          {moment(label).format("MMM DD, YYYY")}
        </span>
        <span className="hours" style={{fontSize:'.75rem', paddingTop: '0px', paddingBottom: '0px', display:'block'}}>
        {moment(label).format("HH:mm")}
        </span>
        <svg width="50" height="11" style={{display: 'block', paddingTop: '0px', paddingBottom: '0px'}}>
          <rect width="5" height="5" style={{fill:'#be0000'}}/>
          <text
            fontSize=".75rem"
            height="5"
            x={10}
            y={10}
          >
          {payload[0] && payload[0].value?`${payload[0].value}`:'null'}
        </text>
        </svg>
        <svg width="50" height="11" style={{display: 'block',paddingTop:'0.5px' }}>
          <rect width="5" height="5" style={{fill:'blue'}}/>
          <text
            fontSize=".75rem"
            height="8"
            x={10}
            y={10}
          >
          {payload[1] && payload[1].value ? `${payload[1].value}`: 'null'}
        </text>
        </svg>
      </div>
    );
  }
  return null;
};

export const CustomizedAxisTick: any = (props: any) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`} >
      <text
        fontSize=".75rem"
        x={0}
        y={2}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-35)"
      >
        {moment(payload.value).format('MMM DD')}
      </text>
    </g>
  );
};
